/* tslint:disable */
/* eslint-disable */
/**
 * LWM portal
 * Lamb-Weston Meijer Portal API documentation
 *
 * The version of the OpenAPI document: 3.3.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CreateRuleSetOutputDTO } from '../model';
// @ts-ignore
import { GetRuleSetsOutputDTO } from '../model';
// @ts-ignore
import { HTTPValidationError } from '../model';
// @ts-ignore
import { RuleSet } from '../model';
// @ts-ignore
import { UpdateRuleSetOutputDTO } from '../model';
// @ts-ignore
import { WriteRuleSetRequest } from '../model';
/**
 * RuleApi - axios parameter creator
 * @export
 */
export const RuleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Create Rule Set
         * @param {WriteRuleSetRequest} writeRuleSetRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRuleSetDockschedulingRulesPost: async (writeRuleSetRequest: WriteRuleSetRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'writeRuleSetRequest' is not null or undefined
            assertParamExists('createRuleSetDockschedulingRulesPost', 'writeRuleSetRequest', writeRuleSetRequest)
            const localVarPath = `/dockscheduling/rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(writeRuleSetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Rule Set
         * @param {string} ruleSetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRuleSetDockschedulingRulesRuleSetIdDelete: async (ruleSetId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleSetId' is not null or undefined
            assertParamExists('deleteRuleSetDockschedulingRulesRuleSetIdDelete', 'ruleSetId', ruleSetId)
            const localVarPath = `/dockscheduling/rules/{rule_set_id}`
                .replace(`{${"rule_set_id"}}`, encodeURIComponent(String(ruleSetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Rule Set
         * @param {string} ruleSetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRuleSetDockschedulingRulesRuleSetIdGet: async (ruleSetId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleSetId' is not null or undefined
            assertParamExists('getRuleSetDockschedulingRulesRuleSetIdGet', 'ruleSetId', ruleSetId)
            const localVarPath = `/dockscheduling/rules/{rule_set_id}`
                .replace(`{${"rule_set_id"}}`, encodeURIComponent(String(ruleSetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List Rule Sets
         * @param {string | null} [locationId]
         * @param {Array<string> | null} [dockIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRuleSetsDockschedulingRulesGet: async (locationId?: string | null, dockIds?: Array<string> | null, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/dockscheduling/rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locationId !== undefined) {
                localVarQueryParameter['location_id'] = locationId;
            }

            if (dockIds !== undefined) {
                localVarQueryParameter['dock_ids'] = dockIds;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update Rule Set
         * @param {string} ruleSetId
         * @param {WriteRuleSetRequest} writeRuleSetRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRuleSetDockschedulingRulesRuleSetIdPut: async (ruleSetId: string, writeRuleSetRequest: WriteRuleSetRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleSetId' is not null or undefined
            assertParamExists('updateRuleSetDockschedulingRulesRuleSetIdPut', 'ruleSetId', ruleSetId)
            // verify required parameter 'writeRuleSetRequest' is not null or undefined
            assertParamExists('updateRuleSetDockschedulingRulesRuleSetIdPut', 'writeRuleSetRequest', writeRuleSetRequest)
            const localVarPath = `/dockscheduling/rules/{rule_set_id}`
                .replace(`{${"rule_set_id"}}`, encodeURIComponent(String(ruleSetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(writeRuleSetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RuleApi - functional programming interface
 * @export
 */
export const RuleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RuleApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Create Rule Set
         * @param {WriteRuleSetRequest} writeRuleSetRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRuleSetDockschedulingRulesPost(writeRuleSetRequest: WriteRuleSetRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateRuleSetOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRuleSetDockschedulingRulesPost(writeRuleSetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete Rule Set
         * @param {string} ruleSetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRuleSetDockschedulingRulesRuleSetIdDelete(ruleSetId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRuleSetDockschedulingRulesRuleSetIdDelete(ruleSetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get Rule Set
         * @param {string} ruleSetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRuleSetDockschedulingRulesRuleSetIdGet(ruleSetId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RuleSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRuleSetDockschedulingRulesRuleSetIdGet(ruleSetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary List Rule Sets
         * @param {string | null} [locationId]
         * @param {Array<string> | null} [dockIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRuleSetsDockschedulingRulesGet(locationId?: string | null, dockIds?: Array<string> | null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRuleSetsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRuleSetsDockschedulingRulesGet(locationId, dockIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update Rule Set
         * @param {string} ruleSetId
         * @param {WriteRuleSetRequest} writeRuleSetRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRuleSetDockschedulingRulesRuleSetIdPut(ruleSetId: string, writeRuleSetRequest: WriteRuleSetRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateRuleSetOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRuleSetDockschedulingRulesRuleSetIdPut(ruleSetId, writeRuleSetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RuleApi - factory interface
 * @export
 */
export const RuleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RuleApiFp(configuration)
    return {
        /**
         *
         * @summary Create Rule Set
         * @param {WriteRuleSetRequest} writeRuleSetRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRuleSetDockschedulingRulesPost(writeRuleSetRequest: WriteRuleSetRequest, options?: any): AxiosPromise<CreateRuleSetOutputDTO> {
            return localVarFp.createRuleSetDockschedulingRulesPost(writeRuleSetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Rule Set
         * @param {string} ruleSetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRuleSetDockschedulingRulesRuleSetIdDelete(ruleSetId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteRuleSetDockschedulingRulesRuleSetIdDelete(ruleSetId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Rule Set
         * @param {string} ruleSetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRuleSetDockschedulingRulesRuleSetIdGet(ruleSetId: string, options?: any): AxiosPromise<RuleSet> {
            return localVarFp.getRuleSetDockschedulingRulesRuleSetIdGet(ruleSetId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List Rule Sets
         * @param {string | null} [locationId]
         * @param {Array<string> | null} [dockIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRuleSetsDockschedulingRulesGet(locationId?: string | null, dockIds?: Array<string> | null, options?: any): AxiosPromise<GetRuleSetsOutputDTO> {
            return localVarFp.listRuleSetsDockschedulingRulesGet(locationId, dockIds, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Rule Set
         * @param {string} ruleSetId
         * @param {WriteRuleSetRequest} writeRuleSetRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRuleSetDockschedulingRulesRuleSetIdPut(ruleSetId: string, writeRuleSetRequest: WriteRuleSetRequest, options?: any): AxiosPromise<UpdateRuleSetOutputDTO> {
            return localVarFp.updateRuleSetDockschedulingRulesRuleSetIdPut(ruleSetId, writeRuleSetRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RuleApi - object-oriented interface
 * @export
 * @class RuleApi
 * @extends {BaseAPI}
 */
export class RuleApi extends BaseAPI {
    /**
     *
     * @summary Create Rule Set
     * @param {WriteRuleSetRequest} writeRuleSetRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleApi
     */
    public createRuleSetDockschedulingRulesPost(writeRuleSetRequest: WriteRuleSetRequest, options?: any) {
        return RuleApiFp(this.configuration).createRuleSetDockschedulingRulesPost(writeRuleSetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete Rule Set
     * @param {string} ruleSetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleApi
     */
    public deleteRuleSetDockschedulingRulesRuleSetIdDelete(ruleSetId: string, options?: any) {
        return RuleApiFp(this.configuration).deleteRuleSetDockschedulingRulesRuleSetIdDelete(ruleSetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Rule Set
     * @param {string} ruleSetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleApi
     */
    public getRuleSetDockschedulingRulesRuleSetIdGet(ruleSetId: string, options?: any) {
        return RuleApiFp(this.configuration).getRuleSetDockschedulingRulesRuleSetIdGet(ruleSetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary List Rule Sets
     * @param {string | null} [locationId]
     * @param {Array<string> | null} [dockIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleApi
     */
    public listRuleSetsDockschedulingRulesGet(locationId?: string | null, dockIds?: Array<string> | null, options?: any) {
        return RuleApiFp(this.configuration).listRuleSetsDockschedulingRulesGet(locationId, dockIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update Rule Set
     * @param {string} ruleSetId
     * @param {WriteRuleSetRequest} writeRuleSetRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleApi
     */
    public updateRuleSetDockschedulingRulesRuleSetIdPut(ruleSetId: string, writeRuleSetRequest: WriteRuleSetRequest, options?: any) {
        return RuleApiFp(this.configuration).updateRuleSetDockschedulingRulesRuleSetIdPut(ruleSetId, writeRuleSetRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
